import {BaseObject} from "@/common/BaseObject";
import {alias, createModelSchema, custom, deserialize, SKIP} from "serializr";
import {Schema} from "@/common/Schema";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export class CurrencyGroupModel extends BaseObject {
    constructor(key = null, code = null) {
        super();

        this._key = key;
        this._code = code;
    }

    static schema() {
        return custom(
          (v) => {
              return v && v.key ? v.key : SKIP;
          },

          v => {
              if (typeof v === 'string') {
                  return RedactorUtils.getCurrencyGroupByKey(v);
              } else if (typeof v === 'object' && v !== null) {
                  return deserialize(CurrencyGroupModel, v);
              } else {
                  return null;
              }
          }
        );
    }

    static schemaByCode() {
        return custom(
          (v) => {
              return (v && typeof v.code === "number") ? v.code : SKIP;
          },

          v => {
              if (typeof v === 'number') {
                  return RedactorUtils.getCurrencyGroups().find(i => i.code === v) || null;
              } else if (typeof v === 'object' && v !== null) {
                  return deserialize(CurrencyGroupModel, v);
              } else {
                  return null;
              }
          }
        );
    }

    static isNone(value) {
        return value instanceof CurrencyGroupModel && value.key === "none";
    }

    static is(value) {
        return value instanceof CurrencyGroupModel &&
          RedactorUtils.getCurrencyGroups().some(v => v.key === value.key);
    }

    static getNone(items) {
        return items.find(item => item?.key === 'none') || null;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get code() {
        return this._code;
    }

    set code(value) {
        this._code = value;
    }

    valid() {
        if (typeof this.key !== "string" || !this.key.trim()) {
            return false;
        }

        if (!Number.isInteger(this.code) || this.code < 0) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new CurrencyGroupModel());
        } else if (target instanceof CurrencyGroupModel) {
            return super.clone(target);
        } else {
            console.log(false);
            return undefined;
        }
    }

    empty() {
        return typeof this.key !== 'string' || this.key.trim() === '';
    }
}

createModelSchema(CurrencyGroupModel, {
    _key: alias("key", Schema.primitive()),
    _code: alias("code", Schema.number()),
});